module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAAi0lEQVR4AWOgC7ghx0okopuG749EkNHPJyLv7oo8uSj44S6QjSKFRcOPxyKfbostm6IUl2l8eZ/0jyeiBDT8fi16dzpPU7t76oay9SlSX64I/XiKV8OvV6Ivl3BPLNJNb/E+mMn345bQjyf4nfRI5MsD0RdnBF+eFHh7Q+T7Y2x+YKiyJRLRQcOgBADZnMbzK5lnxQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/BO.png
// module id = 1096
// module chunks = 0